import { useState } from "react";
import { Scissors, Sparkles, HeartPulse, Droplets, Leaf, ArrowUpRight } from "lucide-react";
import BookingDialog from "@/components/BookingDialog";

const SERVICES_IMG =
  "https://static.prod-images.emergentagent.com/jobs/e65e354b-d9a2-449a-9e1d-ca9880f3773c/images/40ecb337bd32ca1d7a096596620792d79294bc767ba3f3a392272b3e522c6fae.png";

const SALON_IMG =
  "https://static.prod-images.emergentagent.com/jobs/e65e354b-d9a2-449a-9e1d-ca9880f3773c/images/42f5e5a6071accca5a07172f3af4b79b45ca87d1f9a8b7f4aa51ae6731ca40aa.png";

const services = [
  {
    id: "progressiva",
    name: "Escova Progressiva",
    desc: "Fios alinhados, com brilho de vidro e frizz zero por semanas.",
    icon: Sparkles,
    span: "md:col-span-6 md:row-span-2",
    hasImage: true,
    image: SERVICES_IMG,
  },
  {
    id: "corte",
    name: "Corte Feminino",
    desc: "Cortes que valorizam o formato do rosto e a textura natural.",
    icon: Scissors,
    span: "md:col-span-3",
  },
  {
    id: "tratamento",
    name: "Tratamento Capilar",
    desc: "Hidratação profunda, reconstrução e nutrição sob medida.",
    icon: Droplets,
    span: "md:col-span-3",
  },
  {
    id: "recuperacao",
    name: "Recuperação de Fios",
    desc: "Protocolos avançados para cabelos quebradiços e danificados.",
    icon: HeartPulse,
    span: "md:col-span-4",
  },
  {
    id: "queda",
    name: "Queda de Cabelo",
    desc: "Fortalecimento capilar para quedas não-genéticas. Resultados visíveis.",
    icon: Leaf,
    span: "md:col-span-4",
  },
  {
    id: "consultoria",
    name: "Consultoria Personalizada",
    desc: "Diagnóstico completo + plano capilar sob medida para você.",
    icon: Sparkles,
    span: "md:col-span-4",
    hasImage: true,
    image: SALON_IMG,
  },
];

export default function Services() {
  const [openBooking, setOpenBooking] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleBook = (service) => {
    setSelected(service);
    setOpenBooking(true);
  };

  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-16">
          <span className="overline" data-testid="services-overline">
            Nossos Serviços
          </span>
          <h2
            data-testid="services-title"
            className="font-heading text-4xl md:text-5xl font-light tracking-tight mt-4 text-white"
          >
            Tratamentos que <span className="gold-gradient-text italic">revelam</span> a sua melhor versão.
          </h2>
          <div className="gold-line w-24 mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {services.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`service-card p-8 flex flex-col justify-between min-h-[240px] ${s.span || ""} cursor-pointer group`}
                onClick={() => handleBook(s.name)}
                style={{ animationDelay: `${idx * 90}ms` }}
              >
                {s.hasImage && (
                  <div className="absolute inset-0 overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.name}
                      className="service-image w-full h-full object-cover opacity-30 group-hover:opacity-45"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-transparent" />
                  </div>
                )}
                <div className="relative z-10 flex items-start justify-between">
                  <Icon size={28} strokeWidth={1.25} className="text-[#D4AF37]" />
                  <ArrowUpRight
                    size={20}
                    strokeWidth={1.25}
                    className="text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </div>
                <div className="relative z-10 mt-16">
                  <h3 className="font-heading text-2xl md:text-3xl font-light text-white leading-tight">
                    {s.name}
                  </h3>
                  <p className="text-sm text-white/60 font-light mt-3 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <BookingDialog
        open={openBooking}
        onOpenChange={setOpenBooking}
        defaultService={selected}
      />
    </section>
  );
}
